export type CodeNameEntry = {
  code: string;
  name: string;
};

export const getDisplayNameByCode = (code: string, entries: CodeNameEntry[]): string =>
  entries.find(entry => entry.code === code)?.name ?? code;

export const joinDisplayNames = (codes: string[], entries: CodeNameEntry[]): string =>
  codes.map(code => getDisplayNameByCode(code, entries)).join(', ');
